// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   Snackbar.css — Clean, minimal snackbar styles
   ═══════════════════════════════════════════════ */

/* ── Container ── */
.snackbar-container {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}

/* ── Single item ── */
.snackbar-item {
  pointer-events: auto;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 300px;
  max-width: 420px;
  padding: 12px 14px;
  padding-left: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* left color accent bar */
.snackbar-accent {
  flex-shrink: 0;
  width: 4px;
  align-self: stretch;
  border-radius: 10px 0 0 10px;
}

/* ── Icon ── */
.snackbar-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  stroke-width: 2;
  margin-left: 12px;
}

/* ── Message ── */
.snackbar-message {
  flex: 1 1;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.4;
  color: #1e293b;
  word-break: break-word;
}

/* ── Close ── */
.snackbar-close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  color: #94a3b8;
  transition: background 0.15s, color 0.15s;
}

.snackbar-close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #475569;
}

.snackbar-close-icon {
  width: 14px;
  height: 14px;
  stroke-width: 2.2;
}

/* ── Dark mode ── */
.dark .snackbar-item {
  background: #1e293b;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.dark .snackbar-message {
  color: #e2e8f0;
}

.dark .snackbar-close {
  color: #64748b;
}

.dark .snackbar-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .snackbar-container {
    top: 12px;
    right: 12px;
    left: 12px;
  }
  .snackbar-item {
    min-width: 0;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Snackbar.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yEAAyE;EACzE,gBAAgB;EAChB,uFAAuF;AACzF;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════\n   Snackbar.css — Clean, minimal snackbar styles\n   ═══════════════════════════════════════════════ */\n\n/* ── Container ── */\n.snackbar-container {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 99999;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  pointer-events: none;\n}\n\n/* ── Single item ── */\n.snackbar-item {\n  pointer-events: auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 300px;\n  max-width: 420px;\n  padding: 12px 14px;\n  padding-left: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* left color accent bar */\n.snackbar-accent {\n  flex-shrink: 0;\n  width: 4px;\n  align-self: stretch;\n  border-radius: 10px 0 0 10px;\n}\n\n/* ── Icon ── */\n.snackbar-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  stroke-width: 2;\n  margin-left: 12px;\n}\n\n/* ── Message ── */\n.snackbar-message {\n  flex: 1;\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #1e293b;\n  word-break: break-word;\n}\n\n/* ── Close ── */\n.snackbar-close {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 0;\n  color: #94a3b8;\n  transition: background 0.15s, color 0.15s;\n}\n\n.snackbar-close:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #475569;\n}\n\n.snackbar-close-icon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.2;\n}\n\n/* ── Dark mode ── */\n.dark .snackbar-item {\n  background: #1e293b;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.06);\n}\n\n.dark .snackbar-message {\n  color: #e2e8f0;\n}\n\n.dark .snackbar-close {\n  color: #64748b;\n}\n\n.dark .snackbar-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #cbd5e1;\n}\n\n/* ── Responsive ── */\n@media (max-width: 480px) {\n  .snackbar-container {\n    top: 12px;\n    right: 12px;\n    left: 12px;\n  }\n  .snackbar-item {\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
